(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uh-complaint"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-uh-complaint-native]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const form = root.querySelector('form');
    const photos = root.querySelector('[data-uh-complaint-photos]');
    const success = root.querySelector('[data-uh-complaint-success]');
    if (root.dataset.staticFeedback === 'true' && success && new URLSearchParams(window.location.search).get('contact_posted') === 'true') {
      success.hidden = false;
      success.focus();
    }
    if (form && photos) {
      photos.addEventListener('click', () => {
        const order = form.elements.namedItem('contact[Bestellnummer]')?.value.trim() || '';
        const name = form.elements.namedItem('contact[name]')?.value.trim() || '';
        const model = form.elements.namedItem('contact[Modell]')?.value.trim() || '';
        const subject = 'Reklamation Urban Hopper' + (order ? ' – ' + order : '') + ' – Fotos / Belege';
        const body = 'Name: ' + name + '\nBestellnummer / Order number: ' + order + '\nModell / Model: ' + model + '\n\n';
        photos.href = 'mailto:info@urbanminushopper.de?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uh-sales-cart"]) return;
  try {
    
document.addEventListener('change', (event) => {
  if (!event.target.matches('.uh-fulfillment input[type="radio"]')) return;
  const form = event.target.form;
  const update = form.querySelector('button[name="update"]');
  if (update) form.requestSubmit(update);
});

  } catch(e) { console.error(e); }
})();
})();
